import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { UseMutationResult } from '@tanstack/react-query'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type {
  InviteMembersInterface,
  InviteMembersResponse,
} from 'modules/community/types/member-interface'
import { communityKeys } from './key-factory'

export const useInviteMembers = ({
  communityPath,
}: {
  communityPath: string
}): UseMutationResult<InviteMembersResponse, Error, InviteMembersInterface> => {
  const queryClient = useQueryClient()
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.post,
    InviteMembersResponse,
    InviteMembersInterface
  >({
    method: RequestMethodsEnum.post,
  })

  return useMutation({
    mutationKey: communityKeys.invitations.invite(communityPath),
    mutationFn: (data: InviteMembersInterface) =>
      fetcher(`${COMMUNITY_API_PREFIX}/${communityPath}/invite-members`, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: communityKeys.invitations.all })
    },
    retry: false,
  })
}
